module.exports = __webpack_public_path__ + "img/button-s_whiteLP.4f71c65.png";